import { createAction } from '@reduxjs/toolkit';
import { CohortNames, Experiment } from '../types';
import { AB_TESTING_ACTION_TYPES } from './action-types';

export const participatedInAbTestingAnalytics = createAction<{
  abTest: Experiment;
  variant: CohortNames;
}>(AB_TESTING_ACTION_TYPES.PARTICIPATED_IN_AB_TESTING_ANALYTICS);
